import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import IconButton from "@mui/material/IconButton";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import axios from "axios";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CardDataLoader from "../../../uiComponents/CardDataLoader/CardDataLoader";
import DeathOfBirth from "./DeathOfBirth";
import DoctorList from "./DoctorList-4";
import { PatientFormValidation } from "./PatientFormValidation";

const NewPatient =forwardRef((props, ref) => {
  const dispatch = useDispatch();

  // states

  const [loadingCustomId, setLoadingCustomId] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [isPaperLoaderActive, setIsPaperLoaderActive] = useState(false);
  // |-> form state
  const [customId, setCustomId] = useState("");
  const [patientId, setPatientId] = useState("");
  const [selectedDoctorId, setSelectedDoctorId] = useState("");
  const [patientName, setPatientName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [gender, setGender] = useState("");
  const [expanded, setExpanded] = useState(false);
  // states //

  // UseRef
  useImperativeHandle(ref.newPatientReset, () => ({
    resetFormData,
    getPatientDetailsById
  }));
  const getPatientDetailsById = (patientId)=>{
    loadPatientDetails(patientId);
  }
  const doctorListReset = useRef();
  const ageReset = useRef();
  // UseRef // 

  //redux
  const dobYear = useSelector((state) => state.birthOfYear);
  const isNewPatient = useSelector((state) => state.isNewPatient);
  const isLoadPatientDetails = useSelector((state) => state.loadPatientDetails);
  const existingPatientId = useSelector((state) => state.patientId);
  //redux //

  // methodManagement
  const resetFormData = () => {
    getCustomId();
    setPatientId("");
    //
    getCustomId();
    setPatientId("");
    setSelectedDoctorId("");
    setPatientName("");
    setPhoneNumber("");
    setEmail("");
    setAddress("");
    setGender("");
    setExpanded(false);
    doctorListReset.current.resetFormData();
    ageReset.current.resetFormData();
    dispatch({
      type:"birthOfYear_remove", 
    })
  };

  // const handleToggle = () => {
  //   setLoadingSave(!loadingSave);
  // };

  const handleSubmit = () => {
    const data = {};
    data.custom_id = customId;
    data.dob_year = dobYear;
    data.patient_name = patientName;
    data.phone_number = phoneNumber;
    data.email = email;
    data.address = address;
    data.gender = gender;
    data.dentrino_doctors_manager_id = selectedDoctorId;
    console.log("handleSubmit--", data);

    let config = {};
    if (patientId > 0) {
      config = {
        method: "PUT",
        url: `/dentrino-patient-manager/${patientId}`,
        data: { ...data },
      };
    } else {
      config = {
        method: "POST",
        url: "/dentrino-patient-manager",
        data: { ...data },
      };
    }

    if (PatientFormValidation(data)) {
      dispatch({
        type:"isShowBackDrop_update", 
        payload: true
      })
      axios(config)
        .then((res) => {
          dispatch({
            type:"isShowBackDrop_update", 
            payload: false
          })
          toast.success(res.data.msg);
          if (!patientId && res.data.data.id) {
            setPatientId(res.data.data.id);
            dispatch({
              type: "patientId_add",
              payload: res.data.data.id,
            });
          }
        })
        .catch((error) => {
          dispatch({
            type:"isShowBackDrop_update", 
            payload: true
          })
          console.log(error);
        })
        .then(() => {
          console.log("final");
        });
    }
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleRefreshCustomId = () => {
    getCustomId();
  };

  const getCustomId = () => {
    setLoadingCustomId(true);
    axios
      .get("/dentrino-patient-info-generate-customid")
      .then((response) => {
        setLoadingCustomId(false);
        setCustomId(response.data);
      })
      .catch((error) => {
        setLoadingCustomId(false);
        console.log(error);
      })
      .finally(() => {});
  };

  const handleCustomIDChange = (value) => {
    setCustomId(value);
  };
  // methodManagementEND
  // useEffect
  useEffect(() => {
    if (!isLoadPatientDetails) {
      getCustomId();
    }
  }, []);
  useEffect(() => {
    // console.log("TEST-1", isLoadPatientDetails, existingPatientId);
    if (existingPatientId > 0 && isLoadPatientDetails === true) {
      // console.log("Now I wil load patient details . ");
      // loadPatientDetails();
      setPatientId(existingPatientId);
    }
  }, [isLoadPatientDetails, existingPatientId]);

  // useEffect

  const loadPatientDetails = (patientId) => {
    setIsPaperLoaderActive(true);
    console.log("loading patient details ");
    axios
      .get("/dentrino-patient-manager/" + patientId)
      .then((response) => {
        setIsPaperLoaderActive(false);
        console.log(response.data);

        setCustomId(response.data.custom_id);
        // setValue("patient_name", response.data.patient_name);
        // setValue("phone_number", response.data.phone_number);
        // setValue("email", response.data.email);
        // setValue("address", response.data.address);
        // setValue("gender", response.data.gender);
        // console.log("doctor id - ", response.data.dentrino_doctors_manager_id);
        //
        setPatientName(response.data.patient_name);
        setPhoneNumber(response.data.phone_number);
        setEmail(response.data.email);
        setAddress(response.data.address);
        setGender(response.data.gender);
        setPatientId(response.data.id);

        //
        setSelectedDoctorId(response.data.dentrino_doctors_manager_id);
        // setValue("dob_year", 1982);

        // console.log(
        //   "dentrino_patient_personal_info",
        //   response.data["dentrino_patient_personal_info"].dob_year
        // );
        dispatch({
          type: "birthOfYear_add",
          payload: response.data["dentrino_patient_personal_info"].dob_year,
        });
        // setValue("dob_year", response.data.dentrino_patient_personal_info.dateofbirthyear);

        // setValue("email", response.data.email);
      })
      .catch((error) => {
        setIsPaperLoaderActive(false);
        console.log(error);
      });
  };
  const selectedItemData = (itemData) => {
    setSelectedDoctorId(itemData.value);
  };

  return (
    <div>
      {/* <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingSave}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div> */}
      {/* <h3>Patient Entry Form</h3> */}
      <Box sx={{ position: "relative" }}>
        <Card sx={{ maxWidth: 1, boxShadow: 20 }}>
          <CardHeader title="Patient Details" subheader=" " />
          <CardContent sx={{ marginBottom: 10 }}>
            {/* <Box
          sx={{
            bgcolor: "red",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            zIndex:3
          }}
        >
          <CircularProgress />
        </Box> */}
            {/* FROM CONTENT  */}
            <form>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <TextField
                  disabled
                  sx={{ mx: 1 }}
                  size="small"
                  readOnly
                  label="PID"
                  value={patientId}
                ></TextField>

                <Box
                  sx={{
                    p: "0 1px",
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: "theme.color.primary",
                  }}
                >
                  <TextField
                    value={customId}
                    onChange={(e) => handleCustomIDChange(e.target.value)}
                    size="small"
                    label="Custom ID"
                    sx={{ mx: 1 }}
                  />
                </Box>

                <Box
                  sx={{
                    bgcolor: "#F7F7F7",
                    display: "inline-flex",
                    alignItems: "center",
                    borderRadius: 2,
                  }}
                >
                  <IconButton
                    sx={{ p: "10px" }}
                    aria-label="refresh"
                    onClick={handleRefreshCustomId}
                  >
                    {loadingCustomId ? (
                      <CircularProgress size={20} />
                    ) : (
                      <RefreshIcon />
                    )}
                  </IconButton>
                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton
                    type="submit"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>
                </Box>
                <Box sx={{ width: 250, m: 1 }}>
                  <DoctorList
                    selectedItemData={selectedItemData}
                    selectedDoctorId={selectedDoctorId}
                    ref={doctorListReset}
                  />
                </Box>
                <Box>
                  <DeathOfBirth ref={ageReset} />
                </Box>
              </Box>
              <Box sx={{ mt: 2 }}>
                <TextField
                  sx={{ mx: 1 }}
                  size="small"
                  label="Patient Name"
                  value={patientName}
                  onChange={(e) => setPatientName(e.target.value)}
                />
                <TextField
                  sx={{ mx: 1 }}
                  size="small"
                  label="Phone Number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
                <TextField
                  sx={{ mx: 1 }}
                  size="small"
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <TextField
                  size="small"
                  label="Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                {/* gender selection  */}

                <FormControl sx={{ ml: 2 }}>
                  <RadioGroup
                    row
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="Male"
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio />}
                      label="Female"
                    />
                    <FormControlLabel
                      value={3}
                      control={<Radio />}
                      label="Other"
                    />
                  </RadioGroup>
                </FormControl>
                {/* gender selection end */}
                <Button
                  color="success"
                  variant="contained"
                  onClick={handleSubmit}
                >
                  {patientId ? "UPDATE" : "SAVE"}
                </Button>
                {/* <DoctorList control={control} /> */}
                {/* {patientId ? "UPDATE" : "SAVE"} */}
              </Box>
            </form>
            {/* FROM CONTENT  */}
          </CardContent>

          {/* patient info  */}

          {/* form gorup  */}
        </Card>
        {isPaperLoaderActive && <CardDataLoader></CardDataLoader>}
      </Box>
      {/* ACOORDIAN  */}
    </div>
  );
});

export default NewPatient;
